export const colourThemes = Object.freeze({
    VIVID: 'Vivid',
    CALM: 'Calm',
});